"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _activityCreationApi = require("@/api/activityCreationApi");
var _CustomActivityPopup = _interopRequireDefault(require("./CustomActivityPopup"));
var _Item = _interopRequireDefault(require("./Item.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CustomActivity',
  components: {
    ItemActivity: _Item.default,
    CustomActivityPopup: _CustomActivityPopup.default
  },
  data: function data() {
    return {
      pagination: {
        // currentPage: 1, // 默认第几页
        total: 0 // 条数
      },
      queryData: {
        jumpType: 1,
        name: '',
        status: '',
        unionCode: '',
        page: {
          page: 1,
          size: 10
        }
      },
      dataList: []
    };
  },
  created: function created() {
    this.listActivityApi();
  },
  methods: {
    onInitialize: function onInitialize() {
      this.queryData = {
        jumpType: 1,
        name: '',
        status: '',
        page: {
          page: 1,
          size: 10
        }
      };
    },
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.listActivityApi();
    },
    onRest: function onRest() {
      console.log('重置');
      this.onInitialize();
      this.listActivityApi();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.listActivityApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.listActivityApi();
    },
    // 列表
    listActivityApi: function () {
      var _listActivityApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.tableLoading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _activityCreationApi.listActivityApi)(params);
            case 1:
              res = _context.v;
              this.tableLoading = false;
              if (res.code === 0) {
                this.dataList = res.data.records;
                this.pagination.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listActivityApi() {
        return _listActivityApi2.apply(this, arguments);
      }
      return listActivityApi;
    }(),
    onEditor: function onEditor(item) {
      this.$refs.customActivityPopup.open({
        type: 'editor',
        id: item.id,
        name: '编辑活动'
      });
    },
    refreshEditor: function refreshEditor() {
      this.listActivityApi();
    },
    onDelete: function onDelete(val) {
      var _this = this;
      this.$confirm('是否确认删除此活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deleteActivityApi(Number(val.id));
      });
    },
    // 删除活动
    deleteActivityApi: function () {
      var _deleteActivityApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(id) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                id: id
              };
              _context2.n = 1;
              return (0, _activityCreationApi.deleteActivityApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.listActivityApi();
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function deleteActivityApi(_x) {
        return _deleteActivityApi2.apply(this, arguments);
      }
      return deleteActivityApi;
    }()
  }
};